import styled from "styled-components";

export const Row = styled.div`
  align-items: top;
  display: flex;
  justify-content: flex-start;
  margin-top: 0.5rem;
  padding-bottom: 1rem;
`;

export const Col = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items; flex-start;
  padding-left: 1rem;
`;

export const InstructionalItemsCol = styled(Col)`
  width: 75rem;
  width: stretch;
`;

export const InstructionalItemsRow = styled(Row)`
  & > svg {
    margin-top: 1.5rem;
`;
